module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "quickLetter"
    },
    on: {
      "click": function($event) {
        _vm.$refs['letterSelectModal'].open(), _vm.loadTemplates()
      }
    }
  }, [_vm._v("Quick Letter")]), _vm._v(" "), _c('modal', {
    ref: "letterSelectModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left align-bottom"
  }, [_vm._v("Quick Letter")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['letterSelectModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.letterTemplateList,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "preview",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-file-text-o",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.getLetterPreview(props.row)
            }
          }
        })])]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['letterSelectModal'].close(), _vm.closeLetterAlert()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('vmodal', {
    ref: "letterPreviewModal",
    attrs: {
      "draggable": true,
      "adaptive": true,
      "scrollable": true,
      "name": "letterPreview",
      "title": "Letter Body Preview",
      "height": "auto",
      "minHeight": 720,
      "width": "90%",
      "maxWidth": 840
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px",
      "margin-left": "10px",
      "margin-right": "10px",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.$modal.hide('letterPreview'), _vm.closeLetterAlert()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("Letter Body Preview")]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('editor', {
    attrs: {
      "id": "editor",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.editor.content),
      callback: function($$v) {
        _vm.$set(_vm.editor, "content", $$v)
      },
      expression: "editor.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "width": "99%"
    }
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible",
    class: {
      'hidden': _vm.letterAlertHidden
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeLetterAlert()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v("\n                        Letter is being generated.  It will be downloaded to your browser's Downloads folder in a few moments.\n                        You will also find the letter saved in the Auto-Generated Letters section.\n                    ")])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary col-sm-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateLetter
    }
  }, [_vm._v("Generate Letter")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-sm-3 pull-right",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('letterPreview'), _vm.closeLetterAlert()
      }
    }
  }, [_vm._v("Close")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c96221c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuickLetter.vue
// module id = 933
// module chunks = 1